import { createSlice } from "@reduxjs/toolkit";


const statusSlice = createSlice({
    name: 'status',
    initialState: {
        isOnline: true,
        isOnlineModeActive: false
    },
    reducers: {
        setStatus: (state, action) => {
            state.isOnline = action.payload;
            // state.isOnline = false;
        },
        setIsOnlineModeActive: (state, action) => {
            state.isOnlineModeActive = action.payload;
        }
    }
})


export const statusActions = statusSlice.actions;

export default statusSlice.reducer;